import validators from '../../../utils/validators';

const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.trackNumber, 'trackNumber'));
    Object.assign(errors, validators.CheckboxCheckedRange({value: values.channels, min: 1, max: 2}, 'channels'));

    return errors;
};

export default validate;
